<template>
  <div v-if="showBanner" class="cookie-overlay">
    <div class="cookie-banner" :class="{ 'expanded': showCustomize }">

      <!-- Banner principal -->
      <div v-if="!showCustomize" class="cookie-main">
        <div class="cookie-text">
          <div class="cookie-logo-row">
            <img src="/Resources/images/logo/logoFooter.png" class="cookie-logo" alt="Bisson Service"/>
            <h3>Gestion des cookies</h3>
          </div>
          <p>Nous utilisons des cookies pour améliorer votre expérience. Vous pouvez personnaliser vos préférences ou accepter tous les cookies. <span class="cookie-policy-link" @click="navigateToPolicy">Politique de confidentialité</span></p>
        </div>
        <div class="cookie-actions">
          <button class="cookie-btn cookie-btn-reject" @click="rejectAll">Refuser tout</button>
          <button class="cookie-btn cookie-btn-customize" @click="showCustomize = true">Personnaliser</button>
          <button class="cookie-btn cookie-btn-accept" @click="acceptAll">Accepter tout</button>
        </div>
      </div>

      <!-- Panel personnalisation -->
      <div v-if="showCustomize" class="cookie-customize">
        <div class="cookie-customize-header">
          <button class="cookie-back" @click="showCustomize = false">← Retour</button>
          <h3>Personnaliser les préférences</h3>
          <p>Choisissez les catégories de cookies que vous acceptez.</p>
        </div>

        <div class="cookie-categories">

          <div class="cookie-category">
            <div class="cookie-category-header" @click="toggleCategory('necessary')">
              <div class="cookie-category-info">
                <span class="cookie-category-arrow" :class="{ 'open': openCategories.necessary }">&#9654;</span>
                <span class="cookie-category-name">Nécessaires</span>
              </div>
              <span class="cookie-always-active">Toujours actif</span>
            </div>
            <div class="cookie-category-details" v-if="openCategories.necessary">
              <p>Les cookies nécessaires assurent les fonctionnalités de base du site. Ils ne stockent aucune donnée personnellement identifiable.</p>
            </div>
          </div>

          <div class="cookie-category">
            <div class="cookie-category-header" @click="toggleCategory('functional')">
              <div class="cookie-category-info">
                <span class="cookie-category-arrow" :class="{ 'open': openCategories.functional }">&#9654;</span>
                <span class="cookie-category-name">Fonctionnels</span>
              </div>
              <label class="cookie-toggle" @click.stop>
                <input type="checkbox" v-model="consent.functional"/>
                <span class="cookie-toggle-slider"></span>
              </label>
            </div>
            <div class="cookie-category-details" v-if="openCategories.functional">
              <p>Ces cookies permettent certaines fonctionnalités comme le partage sur les réseaux sociaux.</p>
            </div>
          </div>

          <div class="cookie-category">
            <div class="cookie-category-header" @click="toggleCategory('analytical')">
              <div class="cookie-category-info">
                <span class="cookie-category-arrow" :class="{ 'open': openCategories.analytical }">&#9654;</span>
                <span class="cookie-category-name">Analytiques</span>
              </div>
              <label class="cookie-toggle" @click.stop>
                <input type="checkbox" v-model="consent.analytical"/>
                <span class="cookie-toggle-slider"></span>
              </label>
            </div>
            <div class="cookie-category-details" v-if="openCategories.analytical">
              <p>Ces cookies nous aident à comprendre comment les visiteurs interagissent avec notre site (visites, pages vues, source du trafic, etc.).</p>
            </div>
          </div>

          <div class="cookie-category">
            <div class="cookie-category-header" @click="toggleCategory('performance')">
              <div class="cookie-category-info">
                <span class="cookie-category-arrow" :class="{ 'open': openCategories.performance }">&#9654;</span>
                <span class="cookie-category-name">Performance</span>
              </div>
              <label class="cookie-toggle" @click.stop>
                <input type="checkbox" v-model="consent.performance"/>
                <span class="cookie-toggle-slider"></span>
              </label>
            </div>
            <div class="cookie-category-details" v-if="openCategories.performance">
              <p>Ces cookies analysent les indicateurs de performance clés du site pour améliorer l'expérience utilisateur.</p>
            </div>
          </div>

          <div class="cookie-category">
            <div class="cookie-category-header" @click="toggleCategory('advertisement')">
              <div class="cookie-category-info">
                <span class="cookie-category-arrow" :class="{ 'open': openCategories.advertisement }">&#9654;</span>
                <span class="cookie-category-name">Publicitaires</span>
              </div>
              <label class="cookie-toggle" @click.stop>
                <input type="checkbox" v-model="consent.advertisement"/>
                <span class="cookie-toggle-slider"></span>
              </label>
            </div>
            <div class="cookie-category-details" v-if="openCategories.advertisement">
              <p>Ces cookies permettent de vous présenter des publicités personnalisées basées sur vos visites précédentes.</p>
            </div>
          </div>

        </div>

        <div class="cookie-customize-actions">
          <button class="cookie-btn cookie-btn-reject" @click="rejectAll">Refuser tout</button>
          <button class="cookie-btn cookie-btn-save" @click="savePreferences">Sauvegarder</button>
          <button class="cookie-btn cookie-btn-accept" @click="acceptAll">Accepter tout</button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { updateConsent, getConsent } from '../../public/Resources/script/cookieConsent.js';

export default {
  name: 'CookieBanner',
  data: function() {
    return {
      showBanner: false,
      showCustomize: false,
      consent: {
        necessary:     true,
        functional:    false,
        analytical:    false,
        performance:   false,
        advertisement: false,
      },
      openCategories: {
        necessary:     false,
        functional:    false,
        analytical:    false,
        performance:   false,
        advertisement: false,
      },
    };
  },
  mounted: function() {
    var saved = getConsent();
    if (!saved) {
      var self = this;
      setTimeout(function() { self.showBanner = true; }, 800);
    }
  },
  methods: {
    acceptAll: function() {
      this.consent = { necessary: true, functional: true, analytical: true, performance: true, advertisement: true };
      this.save();
    },
    rejectAll: function() {
      this.consent = { necessary: true, functional: false, analytical: false, performance: false, advertisement: false };
      this.save();
    },
    savePreferences: function() {
      this.save();
    },
    save: function() {
      updateConsent(this.consent);
      this.showBanner = false;
      this.showCustomize = false;
    },
    navigateToPolicy: function() {
      this.$router.push('/PolitiqueDeConfidentialiter');
    },
    toggleCategory: function(category) {
      this.openCategories[category] = !this.openCategories[category];
    },
    reopenBanner: function() {
      var saved = getConsent();
      if (saved) this.consent = Object.assign({}, saved);
      this.showBanner = true;
      this.showCustomize = false;
    },
  },
}
</script>

<style scoped>
  .cookie-overlay {
    position: fixed; inset: 0; z-index: 199999;
    background: rgba(0,0,0,0.55);
    display: flex; align-items: flex-end; justify-content: center;
  }
  .cookie-banner {
    width: 100%; max-width: 100%;
    background: linear-gradient(135deg, rgb(var(--secondary)) 0%, rgba(var(--secondary), 0.92) 100%);
    color: white;
    padding: 28px 50px;
    animation: slideUp 0.4s ease;
    border-top: 3px solid rgb(var(--primary));
  }
  .cookie-banner.expanded {
    max-height: 88vh; overflow-y: auto;
    align-self: center;
    max-width: 680px;
    border-radius: 12px;
    margin: 20px;
    border-top: 3px solid rgb(var(--primary));
  }
  @keyframes slideUp {
    from { transform: translateY(100%); opacity: 0; }
    to   { transform: translateY(0);    opacity: 1; }
  }
  .cookie-main { display: flex; align-items: center; justify-content: space-between; gap: 30px; flex-wrap: wrap; }
  .cookie-text { flex: 1; min-width: 260px; }
  .cookie-logo-row { display: flex; align-items: center; gap: 12px; margin-bottom: 10px; }
  .cookie-logo { height: 50px; width: auto; }
  .cookie-logo-row h3 { font-size: 18px; font-weight: 700; margin: 0; color: white; }
  .cookie-text p { font-size: 14px; line-height: 1.5; opacity: 0.88; margin: 0; color: white; }
  .cookie-policy-link { color: rgba(255,255,255,0.85); text-decoration: underline; cursor: pointer; font-size: 13px; }
  .cookie-policy-link:hover { color: #ffffff; }
  .cookie-actions { display: flex; gap: 10px; flex-wrap: wrap; align-items: center; }

  .cookie-btn { padding: 10px 22px; border: none; border-radius: 4px; font-size: 13px; font-weight: 700; cursor: pointer; text-transform: uppercase; letter-spacing: 0.5px; transition: all 0.25s ease; white-space: nowrap; }
  .cookie-btn-accept { background: #ffffff; color: rgb(var(--secondary)); }
  .cookie-btn-accept:hover { background: rgba(255,255,255,0.88); transform: translateY(-1px); }
  .cookie-btn-reject { background: transparent; color: white; border: 2px solid rgba(255,255,255,0.5); }
  .cookie-btn-reject:hover { border-color: white; }
  .cookie-btn-customize { background: rgba(255,255,255,0.12); color: white; border: 1px solid rgba(255,255,255,0.25); }
  .cookie-btn-customize:hover { background: rgba(255,255,255,0.22); }
  .cookie-btn-save { background: rgb(var(--primary)); color: white; }
  .cookie-btn-save:hover { opacity: 0.88; }

  .cookie-customize-header { margin-bottom: 20px; }
  .cookie-back { background: none; border: none; color: rgba(255,255,255,0.7); font-size: 13px; cursor: pointer; padding: 0 0 12px 0; display: block; transition: color 0.2s; }
  .cookie-back:hover { color: white; }
  .cookie-customize-header h3 { font-size: 18px; font-weight: 700; margin-bottom: 8px; color: white; }
  .cookie-customize-header p { font-size: 13px; line-height: 1.5; opacity: 0.85; color: white; }

  .cookie-categories { display: flex; flex-direction: column; gap: 3px; margin-bottom: 20px; }
  .cookie-category { background: rgba(255,255,255,0.07); border-radius: 6px; overflow: hidden; }
  .cookie-category-header { display: flex; align-items: center; justify-content: space-between; padding: 13px 16px; cursor: pointer; transition: background 0.2s; }
  .cookie-category-header:hover { background: rgba(255,255,255,0.05); }
  .cookie-category-info { display: flex; align-items: center; gap: 10px; }
  .cookie-category-arrow { font-size: 10px; transition: transform 0.3s ease; display: inline-block; }
  .cookie-category-arrow.open { transform: rotate(90deg); }
  .cookie-category-name { font-size: 14px; font-weight: 600; color: white; }
  .cookie-always-active { font-size: 11px; color: rgba(255,255,255,0.65); text-transform: uppercase; letter-spacing: 0.5px; }
  .cookie-category-details { padding: 0 16px 13px 34px; }
  .cookie-category-details p { font-size: 12px; line-height: 1.5; opacity: 0.78; color: white; }

  .cookie-toggle { position: relative; display: inline-block; width: 42px; height: 23px; flex-shrink: 0; }
  .cookie-toggle input { opacity: 0; width: 0; height: 0; }
  .cookie-toggle-slider { position: absolute; inset: 0; background: rgba(255,255,255,0.2); border-radius: 23px; cursor: pointer; transition: background 0.3s; }
  .cookie-toggle-slider::before { content: ''; position: absolute; height: 17px; width: 17px; left: 3px; bottom: 3px; background: white; border-radius: 50%; transition: transform 0.3s; }
  .cookie-toggle input:checked + .cookie-toggle-slider { background: rgb(var(--primary)); }
  .cookie-toggle input:checked + .cookie-toggle-slider::before { transform: translateX(19px); }

  .cookie-customize-actions { display: flex; gap: 10px; justify-content: flex-end; flex-wrap: wrap; padding-top: 14px; border-top: 1px solid rgba(255,255,255,0.15); }

  @media (max-width: 768px) {
    .cookie-banner { padding: 20px 24px; }
    .cookie-banner.expanded { margin: 10px; max-height: 94vh; }
    .cookie-main { flex-direction: column; align-items: stretch; gap: 18px; }
    .cookie-actions { flex-direction: column; }
    .cookie-actions .cookie-btn, .cookie-customize-actions .cookie-btn { width: 100%; text-align: center; }
    .cookie-customize-actions { flex-direction: column; }
  }
  @media (max-width: 480px) {
    .cookie-banner { padding: 16px 18px; }
    .cookie-banner.expanded { margin: 6px; border-radius: 8px; }
  }
</style>